module.exports = __webpack_public_path__ + "img/roles-fill.91b6d4e3.svg";